import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { formatReference } from '@skjv/common';
import type { BibleLocation } from '@skjv/common';
import { VersePreview } from '@components/common';

/**
 * History tab content
 */
export const HistoryContent = observer(function HistoryContent() {
  const history = bibleState.bibleHistory;

  const handleLoad = useCallback((location: BibleLocation) => {
    bibleState.setCurrentLocation(location);
  }, []);

  return (
    <>
      {history.length === 0 ? (
        <div className="py-8 text-center text-stone-500 dark:text-stone-400">
          No reading history yet
        </div>
      ) : (
        history.slice(0, 40).map((location, index) => {
          const key = `${location.testamentIndex}-${location.bookIndex}-${location.chapterIndex}-${location.verseIndex}`;

          return (
            <div
              key={`${key}-${index}`}
              className="history-row"
              onClick={() => handleLoad(location)}
            >
              <div className="history-reference">{formatReference(location)}</div>
              <VersePreview location={location} className="history-text" />
            </div>
          );
        })
      )}
    </>
  );
});
